import * as ReactDOM from "react-dom";
import * as React from "react";
import { App } from "src/app";

ReactDOM.render(<App/>, document.getElementById("app"));